import React from "react";
import connect from "Shared/connect";
import Modal from "Shared/Modal";
import { translate } from "Shared/translate";
import DropDown from "Shared/DropDown";
import { initLists, addProductToFavoriteList, addProductToPantryList, createListAndAddProduct, } from "Shared/ListItem/action-creators";
import Dialog, { DialogType } from "Shared/Dialog";
import { isInList } from "./index";
import { favoritePageUrl, pantryPageUrl } from "Shared/known-urls";
import { pathCombine, urlToString } from "Shared/url";
import { Input } from "Shared/Fields";
class AddToListDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onNewConfirm = () => {
            return this.onConfirm(true);
        };
        this.onExistingConfirm = () => {
            return this.onConfirm(false);
        };
        this.onModalClose = () => {
            this.props.close();
            this.resetModalState();
        };
        this.onSelectChange = (selectedList) => this.setState({ selectedList });
        this.state = {
            newName: "",
            selectedList: null,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen) {
            this.props.initLists();
        }
    }
    addToFavorite(isNew) {
        if (isNew) {
            if (this.state.newName === "") {
                return Promise.reject(null);
            }
            return this.props.createListAndAddProduct(this.state.newName, true);
        }
        else if (this.props.pantriesFavorites.favorites.length > 0) {
            const selectedList = this.state.selectedList || this.getFilteredOptions()[0].value;
            return this.props.addProductToFavoriteList(selectedList);
        }
        else {
            console.error("No favorite lists available. Can not add product to list.");
            return Promise.reject(null);
        }
    }
    addToPantry(isNew) {
        if (isNew) {
            if (this.state.newName === "") {
                return Promise.reject(null);
            }
            return this.props.createListAndAddProduct(this.state.newName, false);
        }
        else if (this.props.pantriesFavorites.pantries.length > 0) {
            const selectedList = this.state.selectedList || this.getFilteredOptions()[0].value;
            return this.props.addProductToPantryList(selectedList);
        }
        else {
            console.error("No pantry lists available. Can not add product to list.");
            return Promise.reject(null);
        }
    }
    onConfirm(isNew) {
        if (this.props.type === "favorites") {
            return this.addToFavorite(isNew);
        }
        else if (this.props.type === "pantries") {
            return this.addToPantry(isNew);
        }
    }
    resetModalState() {
        this.setState({ selectedList: null, newName: "" });
    }
    getFilteredOptions() {
        const productNotInList = (list) => !(this.props.listsContainingProduct || {})[list.id];
        return this.props.pantriesFavorites[this.props.type]
            .filter(productNotInList)
            .map((list) => ({
            value: list.id,
            text: list.displayName,
        }));
    }
    render() {
        const isPantry = this.props.type !== "favorites";
        let options = this.getFilteredOptions();
        const hasOptions = !!options && options.length > 0;
        return (React.createElement(Modal, { isOpen: this.props.isOpen, onClose: this.onModalClose, title: isPantry
                ? hasOptions
                    ? translate("/Product/AddToPantry")
                    : translate("/Account/ProductList/NewPantry")
                : hasOptions
                    ? translate("/Product/AddToFavorite")
                    : translate("/Account/ProductList/NewList"), className: "ui-test-add-to-list-dialog", reserveSpaceForCloseButton: true },
            isInList(this.props.listsContainingProduct) && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, isPantry
                    ? translate("/Account/ProductList/AlreadyInPantry")
                    : translate("/Account/ProductList/AlreadyInFavorite")),
                Object.keys(this.props.listsContainingProduct).map((key) => {
                    const pageUrl = isPantry ? pantryPageUrl() : favoritePageUrl();
                    if (!(pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.url)) {
                        return (React.createElement("div", { key: key }, this.props.listsContainingProduct[key]));
                    }
                    const urlWithQuery = urlToString({
                        path: pathCombine(pageUrl.url),
                        query: { activeItemKey: key },
                    });
                    return (React.createElement("div", { key: key },
                        React.createElement("a", { href: urlWithQuery }, this.props.listsContainingProduct[key])));
                }))),
            hasOptions && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, translate("/Product/AddToExistingFavoriteList")),
                React.createElement(DropDown, { onChange: this.onSelectChange, options: options, value: this.state.selectedList || "" }),
                React.createElement(Dialog, { type: DialogType.ChooseAbort, onConfirm: this.onExistingConfirm, onCancel: this.onModalClose, onStatusWasFulfilled: this.onModalClose }))),
            React.createElement("h3", null, isPantry
                ? translate("/Account/ProductList/NewPantry")
                : translate("/Account/ProductList/NewList")),
            React.createElement(Input, { label: isPantry
                    ? translate("/Account/ProductList/CreateNewPantry")
                    : translate("/Account/ProductList/CreateNewFavoritelist"), onChange: (e) => this.setState({ newName: e.target.value }) }),
            React.createElement(Dialog, { type: DialogType.OkCancel, onConfirm: this.onNewConfirm, onCancel: this.onModalClose, onStatusWasFulfilled: this.onModalClose })));
    }
}
const AddToListDialogConnected = connect((state) => ({
    pantriesFavorites: state.pantriesFavorites,
}), (dispatch, { code }) => ({
    initLists: () => dispatch(initLists()),
    addProductToFavoriteList: (listId) => dispatch(addProductToFavoriteList(listId, code)),
    addProductToPantryList: (listId) => dispatch(addProductToPantryList(listId, code)),
    createListAndAddProduct: (newName, isFavorite) => dispatch(createListAndAddProduct(newName, code, isFavorite)),
}))(AddToListDialog);
export default AddToListDialogConnected;
